var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1691_6031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.38574 9.5C2.09074 5.66 5.45599 2.75 9.49999 2.75C13.544 2.75 16.9085 5.66 17.6142 9.5C16.9092 13.34 13.544 16.25 9.49999 16.25C5.45599 16.25 2.09149 13.34 1.38574 9.5ZM9.49999 13.25C10.4946 13.25 11.4484 12.8549 12.1516 12.1517C12.8549 11.4484 13.25 10.4946 13.25 9.5C13.25 8.50544 12.8549 7.55161 12.1516 6.84835C11.4484 6.14509 10.4946 5.75 9.49999 5.75C8.50543 5.75 7.5516 6.14509 6.84834 6.84835C6.14508 7.55161 5.74999 8.50544 5.74999 9.5C5.74999 10.4946 6.14508 11.4484 6.84834 12.1517C7.5516 12.8549 8.50543 13.25 9.49999 13.25ZM9.49999 11.75C8.90326 11.75 8.33096 11.5129 7.909 11.091C7.48704 10.669 7.24999 10.0967 7.24999 9.5C7.24999 8.90326 7.48704 8.33097 7.909 7.90901C8.33096 7.48705 8.90326 7.25 9.49999 7.25C10.0967 7.25 10.669 7.48705 11.091 7.90901C11.5129 8.33097 11.75 8.90326 11.75 9.5C11.75 10.0967 11.5129 10.669 11.091 11.091C10.669 11.5129 10.0967 11.75 9.49999 11.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1691_6031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.04698840e7557c2d810913ced7a0b00b.svg";
export { ForwardRef as ReactComponent };